import { computed, ref } from 'vue'

const MAX_MOBILE_VIEWPORT_WIDTH = 1023
const currentClientWidth = ref(window.innerWidth)
export const isMobileLayout = computed(() => MAX_MOBILE_VIEWPORT_WIDTH >= currentClientWidth.value)

const onResize = () => {
  currentClientWidth.value = window.innerWidth
}

window.addEventListener('resize', onResize)
